import React, { useState, useEffect } from 'react';

const ModalValidarPago = ({
  mostrar,
  onClose,
  onConfirm,
  loading,
  datosPago,
  bancoSeleccionado,
  setBancoSeleccionado,
  folioBanco,
  setFolioBanco,
  labelTPV = "Captura el Número de Autorización TPV:",
  permitirDiscrepancia = true,
  modoModal = "validar",
  tienePinpad = false,
  onCobrarPinpad,
  onCobrarTPV,
  faltante = 0
}) => {
  const [refIncorrecta, setRefIncorrecta] = useState(false);
  const [montoIncorrecto, setMontoIncorrecto] = useState(false);
  const [refVoucher, setRefVoucher] = useState("");
  const [montoVoucher, setMontoVoucher] = useState("");
  const [motivo, setMotivo] = useState("");
  const [autorizaParcial, setAutorizaParcial] = useState(false);
  const [folioTPVComplemento, setFolioTPVComplemento] = useState("");

  const limpiar = () => {
    setRefIncorrecta(false);
    setMontoIncorrecto(false);
    setRefVoucher("");
    setMontoVoucher("");
    setMotivo("");
    setAutorizaParcial(false);
    setFolioTPVComplemento("");
  };

  useEffect(() => { if (mostrar) limpiar(); }, [mostrar]);
  useEffect(() => { limpiar(); }, [bancoSeleccionado]);

  if (!mostrar || !datosPago) return null;

  const esModoComplemento = modoModal === "complemento";
  const importeEsperado = parseFloat(datosPago.importe || 0);
  const abonado = parseFloat(datosPago.abonado || 0);
  const esParcial = datosPago.estatus === "PARCIAL";

  const estiloInput = {
    width: "100%", padding: "10px", boxSizing: "border-box",
    border: "1px solid #ccc", borderRadius: "4px", fontSize: "1rem"
  };

  // =====================================================
  // MODO COMPLEMENTO: cobrar el faltante
  // =====================================================
  if (esModoComplemento) {
    const montoFaltante = parseFloat(faltante || 0);
    const folioListo = folioTPVComplemento.trim() !== "";

    return (
      <div className="modal-overlay">
        <div className="modal-content">
          <h3 className="modal-header">Cobrar Pago Faltante</h3>

          <div className="modal-info-box" style={{ textAlign: "center" }}>
            <p style={{ margin: "0 0 4px 0", fontSize: "0.85rem", color: "#666" }}>
              Abonado ${abonado.toFixed(2)} de ${importeEsperado.toFixed(2)}
            </p>
            <p style={{ margin: 0, fontSize: "0.9rem" }}>
              <strong>Importe a cobrar:</strong>{" "}
              <span style={{ color: "#d9534f", fontWeight: "bold", fontSize: "1.4rem" }}>
                ${montoFaltante.toFixed(2)}
              </span>
            </p>
          </div>

          {tienePinpad ? (
            <div style={{ margin: "18px 0" }}>
              <p style={{ fontSize: "0.9rem", color: "#555", marginBottom: "12px" }}>
                Se enviará el cobro a la terminal Pinpad. Pide al alumno que presente su tarjeta.
              </p>
              <button
                onClick={onCobrarPinpad}
                disabled={loading || montoFaltante <= 0}
                className="btn-pagar-grande"
                style={{
                  width: "100%", padding: "12px", fontSize: "1rem", border: "none",
                  borderRadius: "4px", backgroundColor: "#0056b3", color: "#fff",
                  cursor: loading ? "not-allowed" : "pointer",
                  opacity: loading ? 0.5 : 1
                }}
              >
                {loading ? "Procesando en terminal..." : `Cobrar $${montoFaltante.toFixed(2)} con Pinpad`}
              </button>
            </div>
          ) : (
            <div style={{ margin: "18px 0" }}>
              <div style={{
                padding: "10px", marginBottom: "14px", borderRadius: "4px",
                backgroundColor: "#e8f0fe", border: "1px solid #c6dafc",
                fontSize: "0.85rem", color: "#1a4d8f"
              }}>
                Cobra ${montoFaltante.toFixed(2)} en la terminal TPV y captura abajo el número
                de autorización que imprime el voucher.
              </div>

              <label style={{ display: "block", fontWeight: "bold", marginBottom: "8px", color: "#333" }}>
                Número de Autorización del TPV:
              </label>
              <input
                type="text"
                value={folioTPVComplemento}
                onChange={(e) => setFolioTPVComplemento(e.target.value.toUpperCase())}
                style={estiloInput}
                disabled={loading}
                autoFocus
              />

              {!folioListo && (
                <div style={{
                  marginTop: "12px", padding: "10px", borderRadius: "4px",
                  backgroundColor: "#fff8e1", border: "1px solid #ffe082",
                  color: "#7a5c00", fontSize: "0.85rem"
                }}>
                  ℹ️ Captura el número de autorización del voucher TPV.
                </div>
              )}
            </div>
          )}

          <div className="modal-actions">
            <button onClick={onClose} disabled={loading} className="btn-logout" style={{ width: "auto" }}>
              Cancelar
            </button>
            {!tienePinpad && (
              <button
                onClick={() => onCobrarTPV(folioTPVComplemento.trim())}
                disabled={loading || !folioListo || montoFaltante <= 0}
                className="btn-select validar"
                style={{
                  border: "none",
                  opacity: (loading || !folioListo) ? 0.45 : 1,
                  cursor: (loading || !folioListo) ? "not-allowed" : "pointer"
                }}
              >
                {loading ? "Guardando..." : "Registrar Cobro"}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }

  // =====================================================
  // MODO VALIDAR
  // =====================================================
  const esBBVA = bancoSeleccionado === "2";
  const mostrarCasillas = permitirDiscrepancia && esBBVA && !esParcial;
  const importePorCubrir = esParcial ? +(importeEsperado - abonado).toFixed(2) : importeEsperado;

  let referenciaMostrar = "S/R";
  if (bancoSeleccionado === "1") referenciaMostrar = datosPago.referenciaBanorte || "S/R";
  if (bancoSeleccionado === "2") referenciaMostrar = datosPago.referenciaBBVA || "S/R";
  if (bancoSeleccionado === "3") referenciaMostrar = datosPago.folioTPV || "S/R";

  const montoCapturado = montoVoucher === "" ? null : parseFloat(montoVoucher);
  const montoValido = montoCapturado !== null && !isNaN(montoCapturado) && montoCapturado > 0;
  const diferencia = montoValido ? +(montoCapturado - importeEsperado).toFixed(2) : 0;

  let estadoMonto = "sin_captura";
  if (montoIncorrecto && montoValido) {
    if (diferencia === 0) estadoMonto = "igual";
    else if (diferencia > 0) estadoMonto = "excedente";
    else estadoMonto = "faltante";
  }

    // Si el monto deja de ser menor, la autorizacion de parcial ya no aplica
  const parcialVigente = autorizaParcial && estadoMonto === "faltante";
  const hayDiscrepancia = mostrarCasillas && (refIncorrecta || montoIncorrecto);
  const mostrarMotivo = hayDiscrepancia &&
    (refIncorrecta || (montoIncorrecto && estadoMonto !== "igual" && montoValido));

  const folioVacio = !(folioBanco || "").trim();

  let bloqueado = false;
  let mensajeBloqueo = "";
  let bloqueoGrave = false;

  if (!bancoSeleccionado) {
    bloqueado = true;
    mensajeBloqueo = "Selecciona dónde se realizó el pago.";
  } else if (refIncorrecta && refVoucher.trim() === "") {
    bloqueado = true;
    mensajeBloqueo = "Captura la referencia impresa en el voucher.";
  } else if (montoIncorrecto && !montoValido) {
    bloqueado = true;
    mensajeBloqueo = "Captura el importe impreso en el voucher.";
  } else if (estadoMonto === "faltante" && !parcialVigente) {
    bloqueado = true;
    bloqueoGrave = true;
    mensajeBloqueo = `Faltan $${Math.abs(diferencia).toFixed(2)} para cubrir el total. Marca la casilla de abajo para registrarlo como pago parcial, o pide al alumno que complete el pago.`;
  } else if (folioVacio) {
    bloqueado = true;
    mensajeBloqueo = bancoSeleccionado === "3"
      ? "Captura el número de autorización del TPV."
      : "Captura el folio de autorización del banco.";
  }

  const handleConfirmar = () => {
    if (!hayDiscrepancia) {
      onConfirm(null);
      return;
    }
    onConfirm({
      referencia_pagada: refIncorrecta ? refVoucher.trim() : null,
      importe_pagado: montoIncorrecto && montoValido ? montoCapturado : null,
      motivo: motivo.trim() || null,
      permitir_parcial: parcialVigente
    });
  };

  const estiloCaja = {
    marginBottom: "15px", padding: "12px", borderRadius: "4px",
    border: "1px solid #e0e0e0", backgroundColor: "#fafafa"
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxHeight: "88vh", overflowY: "auto" }}>
        <h3 className="modal-header">
          {esParcial ? "Validar Segundo Voucher" : "Confirmar Pago"}
        </h3>

        <div className="modal-info-box">
          {esParcial ? (
            <>
              <p style={{ margin: "0 0 4px 0", fontSize: "0.85rem", color: "#666" }}>
                Abonado ${abonado.toFixed(2)} de ${importeEsperado.toFixed(2)}
              </p>
              <p style={{ margin: 0 }}>
                <strong>Importe por cubrir:</strong>{" "}
                <span style={{ color: "#d9534f", fontWeight: "bold" }}>
                  ${importePorCubrir.toFixed(2)}
                </span>
              </p>
            </>
          ) : (
            <p style={{ margin: "0 0 5px 0" }}>
              <strong>Importe a Validar:</strong>{" "}
              <span style={{ color: "green", fontWeight: "bold" }}>
                ${importeEsperado.toFixed(2)}
              </span>
            </p>
          )}
        </div>

        <div style={{ marginBottom: "15px" }}>
          <label style={{ display: "block", fontWeight: "bold", marginBottom: "8px", color: "#333" }}>
            ¿Dónde se realizó el pago?
          </label>
          <select
            value={bancoSeleccionado || ""}
            onChange={(e) => setBancoSeleccionado(e.target.value)}
            disabled={loading || esParcial}
            className="search-input"
            style={{ width: "100%", padding: "10px", border: "1px solid #ccc", borderRadius: "4px" }}
          >
            <option value="">-- Selecciona una opción --</option>
            <option value="1">Banorte</option>
            <option value="2">BBVA</option>
            <option value="3">TPV (Plantel)</option>
          </select>
          {esParcial && (
            <small style={{ color: "#666", display: "block", marginTop: "5px" }}>
              El complemento en ventanilla se paga con la misma referencia BBVA.
            </small>
          )}
        </div>

        {bancoSeleccionado && (
          <div style={{ marginBottom: "15px", backgroundColor: "#f8f9fa", padding: "10px", borderRadius: "4px", border: "1px dashed #ccc" }}>
            <p style={{ margin: "0 0 5px 0", fontSize: "0.85rem", color: "#555" }}>
              {bancoSeleccionado === "3"
                ? "Folio registrado en el sistema:"
                : `Se validará utilizando la referencia oficial de ${bancoSeleccionado === "1" ? "Banorte" : "BBVA"}:`}
            </p>
            <p style={{ margin: "0", fontWeight: "bold", fontSize: "1.1rem", color: "#003366", fontFamily: "monospace" }}>
              {referenciaMostrar}
            </p>
          </div>
        )}

        {mostrarCasillas && (
          <div style={estiloCaja}>
            <p style={{ margin: "0 0 10px 0", fontSize: "0.85rem", color: "#555", fontWeight: "bold" }}>
              ¿El voucher tiene diferencias con lo mostrado arriba?
            </p>

            <label style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px", cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={refIncorrecta}
                onChange={(e) => { setRefIncorrecta(e.target.checked); if (!e.target.checked) setRefVoucher(""); }}
                disabled={loading}
              />
              <span style={{ fontSize: "0.9rem" }}>La referencia pagada es distinta</span>
            </label>

            {refIncorrecta && (
              <div style={{ marginBottom: "12px", paddingLeft: "24px" }}>
                <input
                  type="text"
                  placeholder="Referencia impresa en el voucher"
                  value={refVoucher}
                  onChange={(e) => setRefVoucher(e.target.value.toUpperCase().trim())}
                  style={estiloInput}
                  disabled={loading}
                />
              </div>
            )}

            <label style={{ display: "flex", alignItems: "center", gap: "8px", cursor: "pointer" }}>
              <input
                type="checkbox"
                checked={montoIncorrecto}
                onChange={(e) => {
                  setMontoIncorrecto(e.target.checked);
                  if (!e.target.checked) { setMontoVoucher(""); setAutorizaParcial(false); }
                }}
                disabled={loading}
              />
              <span style={{ fontSize: "0.9rem" }}>El importe pagado es distinto</span>
            </label>

            {montoIncorrecto && (
              <div style={{ marginTop: "8px", paddingLeft: "24px" }}>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  placeholder="Importe impreso en el voucher"
                  value={montoVoucher}
                  onChange={(e) => setMontoVoucher(e.target.value)}
                  style={estiloInput}
                  disabled={loading}
                />

                {estadoMonto === "igual" && (
                  <p style={{ margin: "8px 0 0 0", fontSize: "0.85rem", color: "#137333" }}>
                    Este importe coincide con el esperado. Puedes desmarcar la casilla.
                  </p>
                )}
                {estadoMonto === "excedente" && (
                  <p style={{ margin: "8px 0 0 0", fontSize: "0.85rem", color: "#8a6d00", fontWeight: "bold" }}>
                    Pagó ${diferencia.toFixed(2)} de más. Se registrará el importe del voucher.
                  </p>
                )}

                {estadoMonto === "faltante" && (
                  <div style={{ marginTop: "10px", padding: "10px", borderRadius: "4px", backgroundColor: "#fff3cd", border: "1px solid #ffe082" }}>
                    <p style={{ margin: "0 0 8px 0", fontSize: "0.85rem", color: "#7a5c00", fontWeight: "bold" }}>
                      Faltan ${Math.abs(diferencia).toFixed(2)} para cubrir el total.
                    </p>
                    <label style={{ display: "flex", alignItems: "flex-start", gap: "8px", cursor: "pointer" }}>
                      <input
                        type="checkbox"
                        checked={autorizaParcial}
                        onChange={(e) => setAutorizaParcial(e.target.checked)}
                        disabled={loading}
                        style={{ marginTop: "3px" }}
                      />
                      <span style={{ fontSize: "0.85rem", color: "#555" }}>
                        Registrar como pago parcial. El faltante quedará pendiente y podrá cobrarse
                        después con Pinpad, TPV o un segundo voucher.
                      </span>
                    </label>
                  </div>
                )}
              </div>
            )}

              {mostrarMotivo && (
              <div style={{ marginTop: "12px" }}>
                <label style={{ display: "block", fontSize: "0.85rem", fontWeight: "bold", marginBottom: "5px", color: "#333" }}>
                  Observaciones: <span style={{ fontWeight: "normal", color: "#888" }}></span>
                </label>
                <textarea
                  value={motivo}
                  onChange={(e) => setMotivo(e.target.value)}
                  rows={2}
                  style={{ ...estiloInput, fontSize: "0.9rem", resize: "vertical" }}
                  disabled={loading}
                />
              </div>
            )}
          </div>
        )}

        <div style={{ marginBottom: "20px" }}>
          <label style={{ display: "block", fontWeight: "bold", marginBottom: "8px", color: "#333" }}>
            {bancoSeleccionado === "3" ? labelTPV : "Folio de Autorización del Banco:"}
          </label>
          <input
            type="text"
            value={folioBanco}
            onChange={(e) => setFolioBanco(e.target.value.toUpperCase())}
            style={estiloInput}
            disabled={loading}
            autoFocus
          />
          <small style={{ color: "#666", display: "block", marginTop: "5px" }}>
            Valida visualmente el voucher impreso antes de guardar.
          </small>
        </div>

        {bloqueado && mensajeBloqueo && (
          <div style={{
            marginBottom: "15px", padding: "10px", borderRadius: "4px",
            backgroundColor: bloqueoGrave ? "#fce8e6" : "#fff8e1",
            border: bloqueoGrave ? "1px solid #f5c6cb" : "1px solid #ffe082",
            color: bloqueoGrave ? "#c5221f" : "#7a5c00",
            fontSize: "0.85rem",
            fontWeight: bloqueoGrave ? "bold" : "normal"
          }}>
            {bloqueoGrave ? "⛔ " : "ℹ️ "}{mensajeBloqueo}
          </div>
        )}

        <div className="modal-actions">
          <button onClick={onClose} disabled={loading} className="btn-logout" style={{ width: "auto" }}>
            Cancelar
          </button>
          <button
            onClick={handleConfirmar}
            disabled={loading || bloqueado}
            className="btn-select validar"
            style={{
              border: "none",
              opacity: (loading || bloqueado) ? 0.45 : 1,
              cursor: (loading || bloqueado) ? "not-allowed" : "pointer"
            }}
          >
            {loading ? "Guardando..." : (parcialVigente ? "Registrar Abono Parcial" : "Guardar Validación")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ModalValidarPago;